import { Component, inject } from '@angular/core';
import {VwuiModalConfig, VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {ToastService, ProjectService, CompanyTypeService} from '../../services';
import {TranslateService} from '@ngx-translate/core';
import {ProjectDetails} from '../../models';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {FormUtil} from '../../utils';
import {ICompanyType} from '../../models/user/user';

@Component({
    selector: 'app-execute-project-modal',
    templateUrl: './execute-project-modal.component.html',
    standalone: false
})
export class ExecuteProjectModalComponent {
    public modalRef = inject(VwuiModalRef);
    public modalConfig = inject<VwuiModalConfig<{ projectDetails: ProjectDetails; }>>(VwuiModalConfig);
    private projectService = inject(ProjectService);
    private translateService = inject(TranslateService);
    private companyTypeService = inject(CompanyTypeService);
    private toastService = inject(ToastService);


    public loading = false;
    public form: UntypedFormGroup;
    public companyType: ICompanyType = null;

    constructor() {
        const projectLead = this.modalConfig.data.projectDetails.owner;
        this.form = new UntypedFormGroup({
            projectLead: new UntypedFormControl(projectLead, [Validators.required])
        });

        this.companyTypeService.getCompanyType(this.modalConfig.data.projectDetails.companyTypeId).then((companyType) => {
            this.companyType = companyType;
        });
    }

    async submit() {
        FormUtil.validate(this.form);

        if (this.form.valid) {

            this.loading = true;

            const updatedValues = {...this.modalConfig.data.projectDetails};
            updatedValues.owner = this.form.value.projectLead;
            await this.projectService.toExecution(updatedValues)
                .then((_) => {
                    const message = this.translateService.instant('COMPONENT.mandating.in_execution');
                    this.toastService.openSuccess(message);
                    this.modalRef.close(true);
                })
                .catch((error) => {
                    console.error(error);
                    this.toastService.openError(error, this.translateService.instant('ERRORS.project_to_execution_nok'));
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
